import { Popover } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/styles';

export const StyledPopover = withStyles(({ typography }) => ({
  paper: {
    minWidth: '250px',
    marginTop: '19px',
    backgroundColor: '#2D3238',
    borderRadius: '4px',
    padding: '32px 25px',
    color: '#EDF0F4',
    ...typography.body2,
  },
}))(Popover);

export const useStyles = makeStyles(
  (muiTheme) => ({
    container: {
      display: 'flex',
      columnGap: '12px',
    },
    items: {
      display: 'flex',
      margin: '0 0 23px 0',
      flexDirection: 'column',
    },
    itemsTitle: {
      marginBottom: '13px',
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '-10px',
    },
    button: {
      color: '#EDF0F4',
    },
    partnerOnlyWrapper: {
      display: 'block',
      marginBottom: '10px',
    },
    filterLabelWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    labelPartnerOnlyIcon: {
      marginLeft: '10px',
    },
  }),
  { name: 'GenFiltersV2' },
);
